import * as React from 'react'
import Dropzone from 'react-dropzone'

import { Box } from '@factorialco/deprecated-design-system'
import { AutoGrid } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import { Authorized } from 'modules/core/components/Authorized'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

interface Props {
  children: Array<React.ReactElement<ItemProps>>
}

interface ItemProps {
  onDrop?: ((files: File[]) => unknown) | null | undefined
  disableClick?: boolean
  children: React.ReactElement
  key: string | number
}

const ListItem = observer(({ onDrop, disableClick, key, children }: ItemProps) => {
  const {
    company: { subscription },
  } = useCurrentSession()
  if (!onDrop) {
    return (
      <Box
        borderRadius={{ all: 'abs006' }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        style={{
          cursor: 'pointer',
          position: 'relative',
        }}
      >
        {children}
      </Box>
    )
  }

  return (
    <Authorized subscription={subscription}>
      <Dropzone
        key={key}
        onDrop={(files) => {
          onDrop(files)
        }}
        noClick={disableClick}
      >
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div {...getRootProps()}>
            <Box
              borderRadius={{ all: 'abs006' }}
              border={{
                all: {
                  width: isDragActive ? 's2' : 's1',
                  style: isDragActive ? 'dashed' : 'solid',
                  color: isDragActive ? 'viridian800' : 'grey400',
                },
              }}
              style={{
                cursor: 'pointer',
                position: 'relative',
              }}
            >
              <input {...getInputProps()} />
              {children}
            </Box>
          </div>
        )}
      </Dropzone>
    </Authorized>
  )
})

const List = observer(({ children }: Props) => {
  if (!children) return null

  return <AutoGrid>{children}</AutoGrid>
})

export default {
  List,
  ListItem,
}
